import React, { useState } from 'react'
import { Button, Switch, Table, Typography, Space, Image } from 'antd'
import { transactionData } from '../../../Data';
import { ActionButton, AlertModal } from '../../../components';
import { useNavigate } from 'react-router-dom';
const { Text } = Typography;
const Transactiontable = () => {

    const navigate = useNavigate()
    const [deleteitem,setDeleteItem] = useState(false)
    const [switchtext, setSwitchText] = useState(false)
   


    const columns = [
        {
            title: <Text className='fs-15 fw-500 text-nowrap'>Account Holder</Text>,
            dataIndex: 'accountitle',
            
        },
        {
            title: <Text className='fs-15 fw-500 text-nowrap'>Account Number</Text>,
            dataIndex: 'accountnumber',
        },
        {
            title: <Text className='fs-15 fw-500 text-nowrap'>Amount</Text>,
            dataIndex: 'amount'

        },
        {
            title: <Text className='fs-15 fw-500 text-nowrap'>Date</Text>,
            dataIndex: 'date'
        },
        {
            title: <Text className='fs-15 fw-500 text-nowrap'>Action</Text>,
            key: 'action',
            fixed: 'right',
            width: 100,
            render: (_, row) => (
                <Space>
                    {/* <ActionButton
                        title='View Transaction'
                        shape="circle"
                        icon={<Image src='/assets/icons/view.png' width={18} preview={false} />}
                        className='border0 bg-transparent'
                        onClick={() => {navigate(`/projects/detail/${row?.id}`)}}
                    /> */}
                    <ActionButton
                        title='Delete Transaction'
                        shape="circle"
                        icon={<Image src='/assets/icons/delete.png' width={18} preview={false} />}
                        className='border0 bg-transparent'
                        onClick={() => {setDeleteItem({name: row?.accountitle})}}
                    />
                </Space>
            ),
        },
    ];
    return (
        <>
            <Table
                size='large'
                columns={columns}
                dataSource={transactionData}
                className='pagination'
                showSorterTooltip={false}
                scroll={{ x: 1300 }}
                pagination={{
                hideOnSinglePage: true,
                total: 12,
                // pageSize: pagination?.pageSize,
                // defaultPageSize: pagination?.pageSize,
                // current: pagination?.pageNo,
                // size: "default",
                // pageSizeOptions: ['10', '20', '50', '100'],
                // onChange: (pageNo, pageSize) => call(pageNo, pageSize),
                showTotal: (total) => <Button className='brand-bg border0 text-white'>Total: {total}</Button>,
            }}
        />
        <AlertModal
          visible={deleteitem}
          deleteitem={deleteitem}
          switchtext={switchtext}
          onClose={()=>{setDeleteItem(false);setSwitchText(null)}}
        />
        </>
    )
}

export { Transactiontable }